export default __webpack_public_path__ + "static/media/youtube.ff69042c.svg";